import useTranslation from "@babackapp/translations/use-translation";

export function VerificationLoading() {
  const t = useTranslation();

  return (
    <div className="text-center">
      <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-6">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {t("verifyEmail.verifying.title")}
      </h3>
      <p className="text-sm text-gray-600">
        {t("verifyEmail.verifying.description")}
      </p>
    </div>
  );
}